import { BaseApiService } from '@services/baseApiService';
import { AreaOutputDTO } from '@types';
import { ApiResponse, ApiError } from '@/types/api';

class AreaService extends BaseApiService<AreaOutputDTO> {
  constructor() {
    super('areas');
  }

  async create(data: Partial<AreaOutputDTO>): Promise<ApiResponse<AreaOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const roleData = {
      ...data,
    };
    
    return await super.create(roleData);
  }

  async update(id: string, data: Partial<AreaOutputDTO>): Promise<ApiResponse<AreaOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const roleData = {
      ...data,
    };
    
    return await super.update(id, roleData);
  }

  // You can add role-specific methods here if needed
}

export const sectorService = new AreaService(); 